import TimeZone from '@gap/utils/country/TimeZone'

/** The browser's IANA timezone, or undefined where Intl is unavailable or throws. */
export const getBrowserTimeZone = (): TimeZone | undefined => {
   try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone as TimeZone
   } catch {
      return undefined
   }
}
